/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useAdminUsersPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& .MuiTableCell-root': {
        width: 'min-content !important',
      },
      '& .MuiTableCell-footer': {
        width: '100% !important',
      },
      '& .MuiTableCell-body:last-child > div': {
        justifyContent: 'center',
      },
    },
    title: {
      marginBottom: '30px',
    },
    loaderContainer: {
      height: '100%',
      maxHeight: '500px',
      minHeight: '150px',
    },
    success: {
      color: theme.palette.success.main,
    },
    failure: {
      color: theme.palette.error.main,
    },
    youHint: {
      color: theme.palette.tertiary.main,
    },
  }),
);
